import {IsContainHttp} from './common.func';
import {environment} from "../../../environments/environment";

declare global {
  var naver_id_login: any;
}

export const CUSTOM_URL_SCHEME = 'gukeoapp';


export const NAVER_CLIENT_ID = environment.naverClientId;
export const NAVER_CALLBACK_URL = environment.naverCallbackUrl;
export const NAVER_CALLBACK_SIGN = 'naver_callback';

export const GUKEO_API_URL1 = environment.apiUrl;


export const GUKEO_API_URL = GUKEO_API_URL1 + '/';


export const USER_API_URL             = 'v1/user/';
export const USER_LOGIN_API_URL       = USER_API_URL + 'login/';
export const USER_REGISTER_API_URL    = USER_API_URL + 'register/';
export const USER_FCM_TOKEN_API_URL   = USER_API_URL + 'fcm-token/';

export const WORD_API_URL             = 'v1/word/';
export const WORD_DETAIL_API_URL      = WORD_API_URL + 'detail/';
export const WORD_API_IN_URL          = WORD_API_URL + 'in/';
export const WORD_LINK_API_URL        = WORD_API_URL + 'link/';
export const WORD_LINKS_API_URL        = WORD_API_URL + 'links/';
export const WORD_BOOKMARK_API_URL    = WORD_API_URL + 'bookmark/';
export const SAJASEUNGEO_BOOKMARK_API_URL = WORD_API_URL + 'saja/bookmark/';
export const WORD_HOMONYM_API_URL     = WORD_API_URL + 'homonym/';

export const DIALECT_API_URL          = 'v1/dialect2/';
export const DIALECT_DETAIL_API_URL   = DIALECT_API_URL + 'detail/';
export const DIALECT_LINK_API_URL     = DIALECT_API_URL + 'link/';
export const DIALECT_LINKS_API_URL     = DIALECT_API_URL + 'links/';
export const DIALECT_IN_API_URL       = DIALECT_API_URL + 'in/';
export const DIALECT_BOOKMARK_API_URL = DIALECT_API_URL + 'bookmark/';

export const PROVERB_API_URL          = 'v1/proverb/';
export const PROVERB_DETAIL_API_URL   = PROVERB_API_URL + 'detail/';
export const PROVERB_IN_API_URL       = PROVERB_API_URL + 'in/';
export const PROVERB_IN2_API_URL       = PROVERB_API_URL + 'in2/';
export const PROVERB_BOOKMARK_API_URL = PROVERB_API_URL + 'bookmark/';
export const PROVERB_WORD_API_URL     = PROVERB_API_URL + 'word/';

export const VIDEO_API_URL            = 'v1/video2/';
export const VIDEO_IN_API_URL         = VIDEO_API_URL + 'in/';
export const VIDEO_BOOKMARK_API_URL   = VIDEO_API_URL + 'bookmark/';
export const VIDEO_STORY_API_URL      = VIDEO_API_URL + 'story/';
export const VIDEO_CITY_API_URL       = VIDEO_API_URL + 'city/';

export const BBS_API_URL              = 'v1/board/';
export const BBS_PAGE_API_URL         = BBS_API_URL + 'p/';
export const BBS_LIST_IN_API_URL      = BBS_API_URL + 'in/';

export const TOTAL_API_URL            = 'v1/total/';
export const TOTAL_SEARCH_API_URL     = TOTAL_API_URL + 'search/';
export const TOTAL_BOOKMARK_INFO_API_URL = TOTAL_API_URL + 'bookmark/';
export const TOTAL_LINK_INFO_API_URL = TOTAL_API_URL + 'link/';

export const EXAMPLE_API_URL           = 'v1/example/';
export const EXAMPLE_DETAIL_API_URL   = EXAMPLE_API_URL + 'detail/';
export const EXAMPLE_TREE_API_URL     = EXAMPLE_API_URL + 'tree/';
export const EXAMPLE_BOOKMARK_API_URL = EXAMPLE_API_URL + 'bookmark/';

export const SASEUNG2_API_URL         = 'v1/saseung2/';
export const SASEUNG2_HANGUL_API_URL  = SASEUNG2_API_URL + 'hangul/';
export const SASEUNG2_HANJA_API_URL   = SASEUNG2_API_URL + 'hanja/';

export const SASEUNG3_API_URL         = 'v1/saseung3/';
export const SASEUNG3_HANGUL_API_URL  = SASEUNG3_API_URL + 'hangul/';
export const SASEUNG3_HANJA_API_URL   = SASEUNG3_API_URL + 'hanja/';
export const SASEUNG3_BOOKMARK_API_URL = SASEUNG3_API_URL + 'bookmark/';
export const SASEUNG3_WORDS_API_URL   = SASEUNG3_API_URL + 'words/';
export const SASEUNG3_STATS_API_URL   = SASEUNG3_API_URL + 'stats/';

export const SYSTEM_API_URL           = 'v1/system/';
export const SYSTEM_INFO_API_URL      = SYSTEM_API_URL + 'info/';
export const SYSTEM_GREETING_API_URL    = SYSTEM_API_URL + 'greeting/';

export const CONTENT_TYPE_JSON_UTF8   = {'Content-Type': 'application/json; charset=utf-8'};

export const SNS_API_URL              = 'v1/sns/';


export type PAGE = {
  count: number;
  next: string;
  previous: string;
  results: [];
};


/******************************************************************************
 * 단어 목록에서 단어 난이도 필터 수치
 *****************************************************************************/
export enum STAR_FILTER {
  NONE,
  ALL = 0,

  ONE,
  TWO,
  THREE,
  FOUR,

  MAX,
}


export enum VIDEO_CATEGORY {
  NONE,

  WORD,
  DIALECT,
  COOL_EXPR,
  WRONG_EXPR,
  PROVERB,
  LOAN_WORD,
  HOMONYM,
}


/**
 * 게시판 구분자
 */
export enum BBS_CATEGORY {
  NONE,   // 내부용
  NOTICE, // 공지
  USAGE,  // 사용법
}


// 서버에서 보내주는, 단어당 최대 활용의 소리 파일 갯수
export const MAX_EXAMPLE_VOICE = 10;


export type GREETING = {
  title: string;
  message: string;
  region?: string;
};


export type SERVER_INFO = {
  status: string;
  version: {
    soft: string,
    hard: string,
  };
};


export function api_url(url: string): string {
  return IsContainHttp(url) ? url : GUKEO_API_URL1 + url;
}

export function api_url_replace(content: string): string {
  return content.split('"/media/').join('"' + GUKEO_API_URL1 + '/media/');
}
